import { useQuery } from '@tanstack/react-query'
import { printApi } from '@/lib/api/print'

export function useLocalPrintAgent() {
  return useQuery({
    queryKey: ['local-print-agent'],
    queryFn: () => printApi.getLocalAgentStatus(),
    retry: false,
    refetchInterval: (query) => (query.state.data ? 5000 : false),
  })
}

export function isLocalPrintAgentOnline(
  local: Awaited<ReturnType<typeof printApi.getLocalAgentStatus>> | undefined,
): boolean {
  return Boolean(local?.agent_id && (local.online !== false))
}
